import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import FormHelperText from '@zenbusiness/zui/FormHelperText';
import FormLabel from '@zenbusiness/zui/FormLabel';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const FieldLabel = superstyled({
  name: 'SingleSelectField',
  slot: 'FieldLabel',
  tag: FormLabel,
  styles: ({ theme }) => ({
    marginBlockEnd: theme.spacing(0),
    // Override error state color to use primary color
    '&.Mui-error': {
      color: theme.palette.primary.main
    },
    // Hide the asterisk symbol
    '& .MuiFormLabel-asterisk': {
      display: 'none'
    }
  })
});

export const FieldDescription = superstyled({
  name: 'SingleSelectField',
  slot: 'FieldDescription',
  tag: Text,
  propsAdded: {
    size: 'sm',
    color: 'secondary'
  },
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(2)
  })
});

export const OptionsContainer = superstyled({
  name: 'SingleSelectField',
  slot: 'OptionsContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5)
  })
});

export const OptionButton = superstyled({
  name: 'SingleSelectField',
  slot: 'OptionButton',
  tag: Button,
  propsNeeded: ['isSelected'],
  propsAdded: {
    fullWidth: true,
    variant: 'outlined'
  },
  styles: ({ theme, isSelected }) => ({
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    padding: theme.spacing(1.25, 2),
    textAlign: 'left',
    borderRadius: theme.spacing(1.5),
    border: '1px solid',
    borderColor: isSelected ? theme.palette.info.main : theme.palette.divider,
    color: isSelected ? theme.palette.info.main : theme.palette.text.primary,
    textTransform: 'none',

    '&:hover': {
      borderColor: isSelected ? theme.palette.info.main : theme.palette.primary.light,
      transform: 'none',
      boxShadow: 'none'
    },

    '&:focus': {
      outline: `1px solid ${theme.palette.info.main}`
    }
  })
});

export const OptionContent = superstyled({
  name: 'SingleSelectField',
  slot: 'OptionContent',
  tag: Box,
  styles: () => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  })
});

export const OptionLabel = superstyled({
  name: 'SingleSelectField',
  slot: 'OptionLabel',
  tag: Text,
  propsNeeded: ['isSelected'],
  propsAdded: {
    size: 'md'
  },
  styles: ({ isSelected }) => ({
    fontWeight: isSelected ? 600 : 400,
    color: 'inherit',
    lineHeight: 1.5
  })
});

export const OptionDescription = superstyled({
  name: 'SingleSelectField',
  slot: 'OptionDescription',
  tag: Text,
  propsAdded: {
    size: 'sm',
    color: 'secondary'
  },
  styles: ({ theme }) => ({
    marginTop: theme.spacing(0.5),
    lineHeight: 1.4
  })
});

export const OptionIcon = superstyled({
  name: 'SingleSelectField',
  slot: 'OptionIcon',
  tag: ChevronRightIcon,
  propsNeeded: ['isSelected'],
  styles: ({ theme, isSelected }) => ({
    marginLeft: theme.spacing(2),
    color: isSelected ? theme.palette.primary.main : theme.palette.text.secondary,
    fontSize: theme.spacing(2.5),
    width: theme.spacing(2.5),
    height: theme.spacing(2.5)
  })
});

export const FieldHelperText = superstyled({
  name: 'SingleSelectField',
  slot: 'FieldHelperText',
  tag: FormHelperText,
  styles: ({ theme }) => ({
    marginTop: theme.spacing(1.5)
  })
});
